import { IProfileModel } from '../interfaces';

export const ProfileInitialStates: IProfileModel = {
  isLoading: true,
  profileInfo: {},
  isError: false,
};
